import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentUser } from '../services/currentUser.service';
import { Store } from '@ngrx/store';
import * as fromApp from '../app.reducer';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isMobile;
  constructor(
    private currentUser: CurrentUser,
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<fromApp.AppState>,
  ) {}

  ngOnInit() {
    this.store.select('shared').subscribe(store => {
      this.isMobile = store.isMobile;
    });
  }

  public isLoggedIn() {
      const isSharedParamsPersist =
        !!this.route.snapshot.queryParams['access_token'] ||
        !!this.route.snapshot.queryParams['share_token'];
      return !!this.currentUser.getJwtToken() || !!isSharedParamsPersist;

  }

  public isContribFirst() {
    if (this.isMobile) {
      if (this.route.snapshot.queryParamMap.get('signUp')) {
        return true;
      } else {
        return false;
      }
    } else {
      if ((this.router.url.includes('/contribute') && !this.router.url.includes('wizard')
      || this.route.snapshot.queryParamMap.get('signUp'))) {
        return true;
      } else {
        return false;
      }
    }
  }
}
